export default __webpack_public_path__ + "5a8ef86e37bde09d2afa5c4661fe3a35.png";